export default class VoucherCategoryCreateRequest {
    constructor(locale, supportedLocales) {
        this.translations = [];
        supportedLocales.forEach((element) => {
            this.translations[element] = {
                name: '',
            };
        });
    }

    static assign(from, to) {
        if (from) {
            to.locale = from.locale;
        } else {
            to = new VoucherCategoryCreateRequest();
        }
    }

    static copy(from) {
        const to = new VoucherCategoryCreateRequest();
        VoucherCategoryCreateRequest.assign(from, to);
        return to;
    }
}
